import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../core/navigation";
import { useAuthContext } from "../core/contexts/AuthContextProvider";
import { PERMISSION_FEATURES } from "../permissions/types/permission-types";

export const ProtectedFragment = ({ module, children }) => {
  const navigate = useNavigate();
  const { isAuthorizedToAccess, isPermissionLoading, allPermissions } =
    useAuthContext();

  useEffect(() => {
    if (
      module &&
      !isAuthorizedToAccess(module, PERMISSION_FEATURES.ENABLE) &&
      !isPermissionLoading &&
      Object.values(allPermissions).some((arr) => arr.length > 0) //ensure permissions are stored in state
    ) {
      navigate(ROUTES.unauthorizedAccess, { replace: true });
    }
  }, [
    module,
    isAuthorizedToAccess,
    navigate,
    isPermissionLoading,
    allPermissions,
  ]);

  if (module && !isAuthorizedToAccess(module)) {
    return null;
  }

  return children;
};
